export function sortUsers(userOne, userTwo) {
  const usernameOne = userOne.username.toUpperCase();
  const usernameTwo = userTwo.username.toUpperCase();
  if (usernameOne < usernameTwo) {
    return -1;
  }
  if (usernameOne > usernameTwo) {
    return 1;
  }
  return 0;
}



// WEBPACK FOOTER //
// ./src/services/sortUsers.js